<template>
  <v-container class="content-wrapper" fluid>
    <!-- Toggle Buttons -->
    <v-row class="mt-2">
      <v-spacer></v-spacer>
      <v-col cols="2"></v-col>
      <v-col cols="12" sm="6" md="6" class="d-flex justify-center">
        <v-row no-gutters class="d-flex justify-center overflow-x-auto">
          <v-btn-toggle v-model="toggleTab" rounded mandatory class="d-flex">
            <v-btn
              v-if="!filtered"
              value="hosting-institution"
              class="btn-selected"
              @click="toggleTab = 'hosting-institution'"
            >
              Hosting Institution
            </v-btn>
            <v-btn
              v-show="!filtered"
              value="view-all"
              class="btn-selected"
              @click="toggleTab = 'view-all'"
            >
              View All
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        v-if="toggleTab === 'view-all'"
        cols="8"
        xl="8"
        lg="12"
        md="12"
        sm="12"
        class="d-flex justify-end"
      >
        <v-select
          v-model="sortBy"
          :items="itemsSortBy"
          dense
          style="max-width: 245px"
          outlined
          label="Sort By"
          rounded
          hide-details
          return-object
          @input="changeSortBy"
        >
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Filters -->
    <v-row class="mt-0">
      <v-spacer></v-spacer>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" style="border-radius: 24px;">
              <v-card-text>
                <v-text-field
                  v-model.trim="provider.text"
                  rounded
                  placeholder="Search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Hosting Institution:</label>
                <v-autocomplete
                  v-model="provider.institutions"
                  class="mt-2"
                  :items="institutions"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Hosting Institution'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific Domain:</label>
                <v-autocomplete
                  v-model="provider.domains"
                  class="mt-2"
                  :items="domains"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Domain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific SubDomain:</label>
                <v-autocomplete
                  v-model="provider.subDomains"
                  class="mt-2"
                  :items="filteredSubDomains"
                  :item-value="'id'"
                  :item-text="'subDomain'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Subdomain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Structure Type:</label>
                <v-autocomplete
                  v-model="provider.structureTypes"
                  class="mt-2"
                  :items="structureTypes"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Structure Type'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Areas of Activity:</label>
                <v-autocomplete
                  v-model="provider.areasOfActivities"
                  class="mt-2"
                  :items="areasOfActivities"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Areas of Activity'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Emirate:</label>
                <v-autocomplete
                  v-model="provider.emirates"
                  class="mt-2"
                  :items="emirates"
                  :item-value="'id'"
                  :item-text="'description'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Emirate'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-actions class="mt-0 pt-0">
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    @click="clear"
                    outlined
                    block
                    depressed
                    large
                    text
                    class="primary200--text font-weight-bold"
                  >
                    Clear
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    @click="triggerFilters"
                    :disabled="!isProviderValid"
                    block
                    depressed
                    rounded
                    large
                    color="primary200"
                    class="white--text font-weight-bold"
                    data-cy="submit"
                    >Done
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
        <!-- Hosting Institutions -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'hosting-institution' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterInstitution(institution)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <v-img contain :src="institution.logoUrl">
                          <template v-slot:placeholder>
                            <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ institution.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- View All -->
        <v-row v-if="toggleTab === 'view-all' && !filtered">
          <MarketplaceProvidersViewAll :sortParams="sortParams"></MarketplaceProvidersViewAll>
        </v-row>
        <!-- Filtered View ALl -->
        <v-row v-if="filtered">
          <MarketplaceProvidersFilteredViewAll
            :filteredParams="params"
            :sortParams="sortParams"
            @changeTab="toggleChangeTab"
          ></MarketplaceProvidersFilteredViewAll>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import MarketplaceProvidersViewAll from './MarketplaceProvidersViewAll.vue';
import MarketplaceProvidersFilteredViewAll from './MarketplaceProvidersFilteredViewAll.vue';

export default {
  name: 'BrowseCatalogueProviders',
  components: { MarketplaceProvidersViewAll, MarketplaceProvidersFilteredViewAll },
  data() {
    return {
      toggleTab: 'hosting-institution',
      provider: {
        institutions: [],
        domains: [],
        subDomains: [],
        structureTypes: [],
        areasOfActivities: [],
        emirates: [],
        text: '',
        orderable: true,
      },
      institutions: [],
      domains: [],
      allSubDomains: [],
      structureTypes: [],
      areasOfActivities: [],
      emirates: [],
      filtered: false,
      params: {},
      sortParams: '',
      marketplaceProvidersViewAll: '',
      sortBy: null,
      itemsSortBy: [
        { text: 'Default', value: null },
        { text: 'Recently updated', value: 'updatedTimestamp', desc: true },
        { text: 'Recently added', value: 'createdTimestamp', desc: true },
        { text: 'A-Z', value: 'name', desc: false },
      ],
      queries: {},
      hasDefinedParams: {},
      initialToggleTab: '',
    };
  },

  mounted() {
    this.axios.get('/api/v1/hosting-institutions/all').then(res => {
      this.institutions = res.data;
    });
    this.axios.get('/api/v1/scientific-domains').then(res => {
      this.domains = res.data.content;
    });
    this.axios.get('/api/v1/scientific-subdomains').then(res => {
      this.allSubDomains = res.data.content;
    });
    this.axios.get('/api/v1/structure-types').then(res => {
      this.structureTypes = res.data.content;
    });
    this.axios.get('api/v1/areas-of-activity').then(res => {
      this.areasOfActivities = res.data.content;
    });
    this.axios.get('/api/v1/emirates').then(res => {
      this.emirates = res.data.content;
    });
    this.marketplaceProvidersViewAll = this.$route.query.marketplaceProvidersViewAll;
    if (this.marketplaceProvidersViewAll) {
      this.toggleTab = 'view-all';
    }
  },
  created() {
    this.queries = this.$route.query;
    if (this.queries) {
      const paramsQueries = {
        domains: this.queries.domains,
        institutions: this.queries.institutions,
        structureTypes: this.queries.structureTypes,
        areasOfActivity: this.queries.areasOfActivity,
        subDomains: this.queries.subDomains,
        emirate: this.queries.emirate,
        text: this.queries.text,
      };

      this.hasDefinedParams = Object.values(paramsQueries).some(value => value !== undefined);

      if (this.hasDefinedParams) {
        console.log('params', paramsQueries);
        this.filtered = true;
        this.params = paramsQueries;
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.filters === 'true' && query.marketplaceProvidersViewAll) {
          const { ...filterParams } = query;
          if (filterParams.orderable === 'true') filterParams.orderable = true;
          if (filterParams.orderable === 'false') filterParams.orderable = false;
          if (Object.keys(filterParams).length > 0) {
            this.filtered = true;
            this.params = filterParams;
            if (filterParams.text) {
              this.provider.text = filterParams.text;
            }
            if (filterParams.orderable !== undefined) {
              this.provider.orderable = filterParams.orderable;
            }
            if (filterParams.institutions) {
              this.provider.institutions = filterParams.institutions.split(',').map(Number);
            }
            if (filterParams.domains) {
              const domainArray = filterParams.domains.split(/,(?=[A-Z])/);
              this.provider.domains = domainArray.map(d => d.trim());
            }
            if (filterParams.subDomains) {
              this.provider.subDomains = filterParams.subDomains.split(',').map(Number);
            }
            if (filterParams.structureTypes) {
              this.provider.structureTypes = filterParams.structureTypes.split(',').map(Number);
            }
            if (filterParams.areasOfActivity) {
              this.provider.areasOfActivities = filterParams.areasOfActivity.split(',').map(Number);
            }
            if (filterParams.emirate) {
              this.provider.emirates = filterParams.emirate.split(',');
            }
          }
        }
      },
    },
  },
  computed: {
    isProviderValid() {
      const providerFields = [
        ...this.provider.institutions,
        ...this.provider.domains,
        ...this.provider.subDomains,
        ...this.provider.structureTypes,
        ...this.provider.areasOfActivities,
        ...this.provider.emirates,
        this.provider.text,
      ];

      return providerFields.some(field => field);
    },
    filteredSubDomains() {
      if (!this.provider.domains.length) {
        return this.allSubDomains;
      }

      return this.allSubDomains.filter(providerDomains =>
        this.provider.domains.includes(providerDomains.domain),
      );
    },
  },
  methods: {
    toggleChangeTab() {
      this.clear();
    },
    clear() {
      this.provider.institutions = [];
      this.provider.domains = [];
      this.provider.subDomains = [];
      this.provider.structureTypes = [];
      this.provider.areasOfActivities = [];
      this.provider.emirates = [];
      this.provider.text = '';
      this.filtered = false;
      if (this.initialToggleTab) {
        this.toggleTab = this.initialToggleTab;
      }
      if (this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/marketplace/providers',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Providers',
            marketplaceProvidersViewAll: true,
          },
        });
      } else if (!this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/public-catalogue-marketplace/providers',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Providers',
            marketplaceProvidersViewAll: true,
          },
        });
      }
    },
    triggerFilters() {
      const institutionIds = this.provider.institutions.map(institution => institution);
      const domains = this.provider.domains.map(domain => domain);
      const subDomains = this.provider.subDomains.map(subDomain => subDomain);
      const structureTypes = this.provider.structureTypes.map(type => type);
      const areasOfActivities = this.provider.areasOfActivities.map(activity => activity);
      const emirates = this.provider.emirates.map(emirate => emirate);

      const institutionParams = institutionIds.join(',');
      const domainParams = domains.join(',');
      const subDomainsParams = subDomains.join(',');
      const structureTypesParams = structureTypes.join(',');
      const areasOfActivitiesParams = areasOfActivities.join(',');
      const emiratesParams = emirates.join(',');

      const params = {
        institutions: institutionParams,
        domains: domainParams,
        subDomains: subDomainsParams,
        text: this.provider.text,
        structureTypes: structureTypesParams,
        areasOfActivity: areasOfActivitiesParams,
        emirate: emiratesParams,
      };

      this.deleteEmptyProperties(params);
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    filterInstitution(institution) {
      const institutionId = institution.id;
      const params = {
        institutions: institutionId,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    changeSortBy(selected) {
      let params = '';

      if (selected && selected.value) {
        const sortField = selected.value;
        const sortOrder = selected.desc ? 'desc' : 'asc';
        params = `sort=${sortField}+${sortOrder}`;
        this.sortParams = params;
      } else {
        this.sortParams = '';
      }
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
